import PropTypes from 'prop-types'
import React from 'react';
import {
    Button,
    Container,
    Header,
    Icon,
} from 'semantic-ui-react'
import { openInNewTab } from '../util/util';

const HomepageHeading = ({ mobile }) => (
    <Container text>
        <Header
            as='h1'
            content='TriNuts Pampanga'
            inverted
            style={{
                fontSize: mobile ? '2em' : '4em',
                fontWeight: 'normal',
                marginBottom: 0,
                marginTop: mobile ? '1.5em' : '3em',
            }}
        />
        <Header
            as='h2'
            content='Choose healthy. Get your TriNuts baked peanuts today.'
            inverted
            style={{
                fontSize: mobile ? '1.5em' : '1.7em',
                fontWeight: 'normal',
                marginTop: mobile ? '0.5em' : '1.5em',
            }}
        />
        <Button onClick={() => openInNewTab("https://www.facebook.com/trinutspampanga")} primary size='huge'>
            Facebook page
      <Icon name='right arrow' />
        </Button>
    </Container>
)

HomepageHeading.propTypes = {
    mobile: PropTypes.bool,
}

export default HomepageHeading;